export function makeRegisterFormDecline(contactId, inputData) {
    let formData = new FormData();
    formData.append('id', contactId);
    formData.append('confirmCruise', inputData.confirmCruise);

    return formData;
}
